<!--
  ~ Copyright (c) Worldline 2023.
  -->

<!DOCTYPE html>

<main role="main">
    <h2>
        {{ 'wait.title' | translate }}
    </h2>
    <section class="infoBox">
        <p *ngIf="!errorMsg">{{ 'wait.content.text' | translate }}</p>
        <p id="signature-error-msg" *ngIf="errorMsg">{{ errorMsg | translate}}</p>
    </section>

    <p class="back-link" [hidden]="spinneractive">
        <span id="cancel-link" (click)="confirmCancel()">{{ 'evidences.cancel' | translate }}</span>
    </p>

</main>
